module.exports = __webpack_public_path__ + "static/media/boy-10.e466e247.svg";